import Swiper, {Navigation} from 'swiper';
import GLightbox from "glightbox";

document.addEventListener("DOMContentLoaded", function (event) {

    // INIT MENUBUTTON
    const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');
    menu_button.addEventListener('click', () => {
        document.body.classList.toggle('body--show');
    })

    // CLOSE MENU ON NAV LINK CLICK
    const nav_links = document.querySelectorAll('.nav_link');
    nav_links.forEach(function (nav_link) {
        nav_link.addEventListener('click', () => {
            document.body.classList.remove('body--show');
        });
    });

    // INIT LIGHTBOX
    const lightbox = GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    // INIT TEASER MODALS
    const modalTriggers = document.querySelectorAll('[data-modal-target]');
    modalTriggers.forEach(function (trigger) {
        const modal = document.getElementById(trigger.dataset.modalTarget);
        if (!modal) return;

        trigger.addEventListener('click', (event) => {
            if (event.target.closest('a, dialog')) return;
            modal.showModal();
        });

        trigger.addEventListener('keydown', (event) => {
            if (event.target !== trigger) return;
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            modal.showModal();
        });

        modal.addEventListener('click', (event) => {
            if (event.target === modal) {
                modal.close();
            }
        });

        modal.querySelectorAll('[data-modal-close]').forEach(function (closeButton) {
            closeButton.addEventListener('click', () => {
                modal.close();
            });
        });
    });

    // INIT SWIPER
    const sliders = document.querySelectorAll('.swiper');
    sliders.forEach(function (slider) {
        const swiper = new Swiper(slider, {
            // configure Swiper to use modules
            modules: [Navigation],
            effect: 'slide',
            direction: 'horizontal',
            slidesPerView: 1,
            loop: true,

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    });

    // FIXED HEADER
    window.addEventListener('scroll', () => {
        if (document.documentElement.scrollTop > 30 || document.body.scrollTop > 30){
            document.body.classList.add('menu--fixed');
        } else {
            document.body.classList.remove('menu--fixed');
        }
    });
});
